import { useEffect, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from  "react-router-dom"
import shuffleArray from "../../hooks/useArrayShuffle"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination } from "@mui/material"
import Loader from "../../components/utilities/Loader/Loader"
import AssociationDetails from "../../components/AssociationAdmin/AssociationDetails"

export default function MyInvitationsPage() {
    const navigate = useNavigate()
    const location = useLocation()
    
    const {invitationId} = useParams()

    const [loading, setLoading] = useState(false)
    const [invitations, setInvitations] = useState([])
    const [currentInvitation, setCurrentInvitation] = useState(null)
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)
    const [filter, setFilter] = useState({
        search: '', 
        from: '',
        to: ''
    })

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);

    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleStatusOpen = async(invitation, status) => {
        await setCurrentInvitation({...invitation, inviteStatus: status})
        await setConfirmOpen(true)
    }

    const handleFilterChange = (e) => {
        const {name, value} = e.target

        setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const fetchInvitations = () => {
        setLoading(true)
        const url = invitationId ? `/user/associations/invitation/all/${invitationId}?page=${page}` : `/user/associations/invitation/all?page=${page}`

        axiosInstance.post(url, filter)
              .then(response => {
                shuffleArray.fisherYatesShuffle(response.data.data.data, response.data.data.length)
                setInvitations(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    const confirmInvitation = () => {
        setConfirmOpen(false)
        setIsConfirmLoading(true)
        axiosInstance.post(`/user/associations/invitation/confirm/${currentInvitation?.id}`, currentInvitation)
            .then(res => {
                toast.success(res.data.message)
                fetchInvitations()
                // navigate('/app/associations')
            })
            .catch(err => {
                toast.error('An error occured. Please, try again')
            })
            .finally(() => setIsConfirmLoading(false))
    }

    useEffect(() => {
        if(invitationId) {
            localStorage.setItem('intendedRoute', location.pathname);
        }

        fetchInvitations()
    }, [page])


    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Association Invitations</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">My Invitations</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            {/* <div className="row row-cols-xxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1">
                <div className="col">
                    <div className="card">
                        <div className="card-body d-flex">
                            <div className="flex-grow-1">
                                <h4>4751</h4>
                                <h6 className="text-muted fs-13 mb-0">Total Invites</h6>
                            </div>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-warning-subtle text-warning fs-22 rounded">
                                    <i className="ri-upload-2-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body d-flex">
                            <div className="flex-grow-1">
                                <h4>3423</h4>
                                <h6 className="text-muted fs-13 mb-0">Accepted</h6>
                            </div>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-success-subtle text-success fs-22 rounded">
                                    <i className="ri-remote-control-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body d-flex">
                            <div className="flex-grow-1">
                                <h4>354</h4>
                                <h6 className="text-muted fs-13 mb-0">Pending</h6>
                            </div>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-info-subtle text-info fs-22 rounded">
                                    <i className="ri-flashlight-fill"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body d-flex">
                            <div className="flex-grow-1">
                                <h4>2762</h4>
                                <h6 className="text-muted fs-13 mb-0">Declined</h6>
                            </div>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-danger-subtle text-danger fs-22 rounded">
                                    <i className="ri-hand-coin-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body d-flex">
                            <div className="flex-grow-1">
                                <h4>1585</h4>
                                <h6 className="text-muted fs-13 mb-0">Invites Today</h6>
                            </div>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-primary-subtle text-primary fs-22 rounded">
                                    <i className="ri-donut-chart-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="card">
                <div className="card-body">
                    <div className="row g-2">
                        <div className="col-xl-3 col-md-6">
                            <div className="search-box">
                                <input 
                                    type="text" 
                                    className="form-control search" 
                                    placeholder="Search applicants..." 
                                    name="search"
                                    value={filter.search}
                                    onChange={handleFilterChange}
                                    />
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                        <div className="col-xl-2 col-md-4">
                            <div className="input-group">
                                <span className="input-group-text" id="basic-addon2">From</span>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    placeholder="Start Date" 
                                    name='from'
                                    value={filter.from}
                                    onChange={handleFilterChange}
                                    />
                            </div>
                        </div>
                        {/* <!--end col--> */}
                        <div className="col-xl-2 col-md-4">
                            <div className="input-group">
                                <span className="input-group-text" id="basic-addon2">To</span>
                                <input type="date" 
                                    className="form-control" 
                                    placeholder="Start Date" 
                                    name='to'
                                    value={filter.to}
                                    onChange={handleFilterChange}
                                    />
                            </div>
                        </div>
                        {/* <!--end col--> */}
                        <div className="col-xl-1 col-md-4">
                            <button className="btn btn-success w-100" onClick={fetchInvitations}>Filter</button>
                        </div>
                    </div>
                    {/* <!--end row--> */}
                </div>
            </div>

            {invitations.length  > 0 && invitations.map(invitation => (
                <div className="row">
                    <div className="col-xxl-3 col-sm-6 project-card">
                        <div className="card card-height-100">
                            <div className="card-body cursor-pointer" onClick={() => setCurrentInvitation(invitation)} data-bs-toggle="offcanvas" data-bs-target="#association-view-offcanvas">
                                <div className="d-flex flex-column h-100">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <p className="text-muted mb-4">{invitation.created_at}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-0">
                                        <div className="flex-shrink-0 me-3">
                                            <div className="avatar-sm">
                                                <span className="avatar-title bg-warning-subtle rounded p-2">
                                                    <img src="/assets/images/brands/slack.png" alt="" className="img-fluid p-1" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-15"><a href="apps-projects-overview.html" className="text-body">{invitation?.association?.name}</a></h5>
                                            <p className="text-muted text-truncate-two-lines mb-3">{invitation?.association?.description} </p>
                                        </div>
                                    </div>
                                    {/* <div className="mt-auto">
                                        <div className="d-flex mb-2">
                                            <div className="flex-grow-1">
                                                <div>Members</div>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <div>20</div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>

                            </div>
                            {/* <!-- end card body --> */}
                            <div className="card-footer bg-transparent border-top-dashed py-2">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <div className="avatar-group">
                                            <a href="javascript: void(0);" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Darline Williams">
                                                <div className="avatar-xxs">
                                                    <img src="/assets/images/users/avatar-2.jpg" alt="" className="rounded-circle img-fluid" />
                                                </div>
                                            </a>
                                            <a href="javascript: void(0);" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Sylvia Wright">
                                                <div className="avatar-xxs">
                                                    <div className="avatar-title rounded-circle bg-secondary">
                                                        S
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <a type="button" className="btn btn-soft-danger btn-sm flex-shrink-0" onClick={() => handleStatusOpen(invitation, 'declined')}>
                                            Decline
                                        </a>
                                        <a type="button" className="btn btn-soft-primary btn-sm flex-shrink-0 ms-2" onClick={() => handleStatusOpen(invitation, 'approved')}>
                                            Accept
                                        </a>
                                    </div>

                                </div>

                            </div>
                            {/* <!-- end card footer --> */}
                        </div>
                        {/* <!-- end card --> */}
                    </div>
                    {/* <!-- end col --> */}
                </div>
            ))}
            {invitations.length == 0 && (
                <div className="col-sm-12 alert alert-info text-center">
                    No record found
                </div>
            )}
            {/* <!-- end row --> */}

            <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                {/* <div className="col-sm-6">
                    <div>
                        <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                    </div>
                </div> */}
                {/* <!-- end col --> */}
                <div className="col-sm-12 d-flex justify-content-end">
                    <Pagination
                        onChange={handlePageChange}  
                        count={pageCount} 
                        color="primary" 
                        shape="rounded"
                        size="small"
                        page={page}
                    />
                </div>
                {/* <!-- end col --> */}
                {loading && <Loader />}
            </div>
            {/* <!-- end row --> */}


        {/* Treat Application Dialog */}
        {currentInvitation && (
          <>
            <Dialog
              open={confirmOpen}
              onClose={() => setConfirmOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {currentInvitation.inviteStatus == 'approved' ? 'Accept' : 'Decline'} <b className="text-primary">
                    {currentInvitation.association?.name}
                </b>'s {" "} invitation
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={() => setConfirmOpen(false)}>
                  Cancel
                </Button>
                <Button onClick={confirmInvitation} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {isConfirmLoading && <Loader />}
            </Dialog>

            {loading && <Loader />}
          </>
        )}


            {/* <!-- Association View --> */}
            <div className="offcanvas offcanvas-end border-0" tabindex="-1" id="association-view-offcanvas">
                <div className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
                    <h5 className="m-0 me-2 text-white">Association Profile</h5>

                    <button type="button" className="btn-close btn-close-white ms-auto" id="customizerclose-btn"
                        data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body p-0 bg-light">
                    <div data-simplebar className="h-100">
                        <div className="p-4">
                            <AssociationDetails currentAssociation={currentInvitation?.association} />
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer border-top p-3 text-center">
                    <div className="row">
                        <div className="col-6">
                            <button data-bs-dismiss="offcanvas" type="button" className="btn btn-light w-100" id="reset-layout">Cancel</button>
                        </div>
                        <div className="col-6">
                            <a onClick={() => handleStatusOpen(currentInvitation, 'approved')} type="button" className="btn btn-primary w-100">Accept</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}